export const PART_TIME_TECHNICIAN_BOOKING_STATUS_OPTIONS = [
  "Sleep Test Scheduled",
  "Reserve Sleep Set",
  "Transferred To Center",
  "Assigned",
  "Technician Scored",
];

const normalizedValue = (value) => String(value || "").trim();

export const isPartTimeSleepTechnician = (
  currentUser = {},
  technicians = [],
) => {
  const roles = Array.isArray(currentUser.roles) ? currentUser.roles : [];
  const displayName = normalizedValue(currentUser.displayName);

  if (!roles.includes("sleep_technician") || !displayName) {
    return false;
  }

  return (Array.isArray(technicians) ? technicians : []).some(
    (technician) =>
      normalizedValue(technician && technician.name) === displayName &&
      normalizedValue(technician && technician.employmentType) === "Part Time",
  );
};

export const getPartTimeTechnicianBookingStatusOptions = (currentStatus) => {
  const currentStatusValue = currentStatus || "";

  if (
    !currentStatusValue ||
    PART_TIME_TECHNICIAN_BOOKING_STATUS_OPTIONS.includes(currentStatusValue)
  ) {
    return PART_TIME_TECHNICIAN_BOOKING_STATUS_OPTIONS;
  }

  return [
    currentStatusValue,
    ...PART_TIME_TECHNICIAN_BOOKING_STATUS_OPTIONS,
  ];
};

export const canPartTimeTechnicianSetBookingStatus = (
  nextStatus,
  currentStatus,
) =>
  nextStatus === currentStatus ||
  PART_TIME_TECHNICIAN_BOOKING_STATUS_OPTIONS.includes(nextStatus);
